import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import BlocksSoundsItem from "../components/BloksSoundsItem";

const useStyles = makeStyles((theme) => ({
  textLightBig: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "24px",
    fontWeight: 300,
    color: "#114668",
    alignSelf: "center",
    marginBottom: "12px",
  },
  box: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px 24px 0px 24px",
    flexDirection: "column",
  },
  break: {
    width: "100%",
    height: "1px",
    marginBottom: "18px",
    marginTop: "18px",
    backgroundColor: "#bcbcbc",
  },
}));

const BlocksSoundsView = ({ soundBlockLevel, soundBlockLevelChoices }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <Box className={classes.box}>
        <Typography className={classes.textLightBig}>
          {t("mobile_frame.home.current_configuration")}
        </Typography>
        <BlocksSoundsItem
          label={soundBlockLevelChoices[soundBlockLevel].label}
          image={soundBlockLevelChoices[soundBlockLevel].image}
          onClick={() => {}}
        />
        <Box className={classes.break} />
      </Box>
      <Box className={classes.box}>
        <Typography className={classes.textLightBig}>
          {t("mobile_frame.home.select_new_configuration")}
        </Typography>
        {Object.keys(soundBlockLevelChoices).map((itemKey, index) => {
          const soundBlockLevelItem = soundBlockLevelChoices[itemKey];
          return (
            <BlocksSoundsItem
              label={soundBlockLevelItem.label}
              image={soundBlockLevelItem.image}
              onClick={soundBlockLevelItem.onClick}
              key={index}
            />
          );
        })}
        <Box className={classes.break} />
      </Box>
    </>
  );
};

export default BlocksSoundsView;
